export default __webpack_public_path__ + "static/media/uc_product.23adefe9.webp";